import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BirthdayAlertComponent } from './birthday-alert/birthday-alert.component';
import { AdminComponent } from '../admin/admin.component';
import { SmsSettingComponent } from './sms-setting/sms-setting.component';
import { TemplateComponent } from './template/template.component';
import { MarksAlertComponent } from './marks-alert/marks-alert.component';
import { FeeDueAlertComponent } from './fee-due-alert/fee-due-alert.component';
import { EmergencyMessageComponent } from './emergency-message/emergency-message.component';
import { GroupComponent } from './group/group.component';
import { ContactComponent } from './contact/contact.component';
import { SmsBalanceComponent } from './sms-balance/sms-balance.component';
import { FeeDueAlertPrintComponent } from './fee-due-alert-print/fee-due-alert-print.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'smssetting', component: SmsSettingComponent, pathMatch: 'full' },
      { path: 'template', component: TemplateComponent, pathMatch: 'full' },
      { path: 'group', component: GroupComponent, pathMatch: 'full' },
      { path: 'contact', component: ContactComponent, pathMatch: 'full' },
      { path: 'feeduealert', component: FeeDueAlertComponent, pathMatch: 'full' },
      { path: 'emergencymessage', component: EmergencyMessageComponent, pathMatch: 'full' },
      { path: 'marksalert', component: MarksAlertComponent, pathMatch: 'full' },
      { path: 'birthdayalert', component: BirthdayAlertComponent, pathMatch: 'full' },
      { path: 'smsbalance', component: SmsBalanceComponent, pathMatch: 'full' },


    ]
  },
  {
    path: '', children: [      
      { path: 'feeduealertprint', component: FeeDueAlertPrintComponent, pathMatch: 'full' }
     
    ]
  }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmsRoutingModule { }
